var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h5", { staticClass: "text-h5 q-mt-lg q-mb-md" }, [
        _vm._v(_vm._s(_vm.$t(_vm.game_data.game_name)))
      ]),
      _c(
        "q-collapsible",
        {
          staticClass: "shadow-2 q-pa-sm q-ma-xs rounded-border",
          attrs: {
            icon: "far fa-check-square",
            "right-icon": "far fa-check-square",
            label: _vm.$t("how_to_create_the_game")
          }
        },
        [
          _c("div", { staticClass: "q-ma-sm" }, [
            _c("p", [
              _vm._v(_vm._s(_vm.$t("fill_in_the_blanks_instructions")))
            ]),
            _c("p", { staticClass: "text-bold" }, [
              _vm._v(_vm._s(_vm.$t("example")))
            ]),
            _c("p", [
              _vm._v(_vm._s(_vm.$t("fill_in_the_blanks_instructions_example")))
            ]),
            _c("p", { staticClass: "q-mt-lg" }, [
              _c("em", [
                _c("strong", [_vm._v(_vm._s(_vm.$t("warning") + ": "))]),
                _vm._v(_vm._s(_vm.$t("create_game_before_save")))
              ])
            ])
          ])
        ]
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12" },
        [
          _c(
            "q-field",
            { staticClass: "col-5", attrs: { count: 1024 } },
            [
              _c("q-input", {
                staticClass: "q-mt-lg",
                attrs: {
                  debounce: "1000",
                  clearable: "",
                  "clear-icon": "close",
                  filled: "",
                  color: "primary",
                  type: "textarea",
                  error: _vm.$v.game_data.game_text.$error,
                  placeholder: _vm.$t("add_the_game_sentences_here")
                },
                on: { input: _vm.checkGame, clear: _vm.resetGame },
                model: {
                  value: _vm.game_data.game_text,
                  callback: function($$v) {
                    _vm.$set(_vm.game_data, "game_text", $$v)
                  },
                  expression: "game_data.game_text"
                }
              })
            ],
            1
          ),
          _vm.game_data.game_options.length
            ? _c(
                "div",
                { staticClass: "col-xs-12 col-sm-12 q-mt-md" },
                [
                  _c("p", { staticClass: "text-bold" }, [
                    _vm._v(_vm._s(_vm.$t("words")))
                  ]),
                  _vm._l(_vm.game_data.game_options, function(opt, index) {
                    return _c(
                      "span",
                      { key: index, staticClass: "q-my-sm q-mr-sm" },
                      [
                        _c(
                          "q-chip",
                          {
                            attrs: { color: "primary", "text-color": "white" }
                          },
                          [_vm._v(_vm._s(opt.text))]
                        )
                      ],
                      1
                    )
                  })
                ],
                2
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "row justify-end q-mr-md q-mt-sm" },
            [
              _c("q-btn", {
                attrs: {
                  color: "secondary",
                  label: _vm.$t("preview"),
                  disable:
                    _vm.game_data.game_text &&
                    _vm.game_data.game_text.length < 10
                },
                on: { click: _vm.buildGamePreview }
              })
            ],
            1
          ),
          _vm.show_game_preview
            ? _c("fill-in-the-blanks-preview", {
                attrs: {
                  show_game_preview: _vm.show_game_preview,
                  game_name: _vm.game_data.game_name,
                  game_words_arr: _vm.game_data.game_words_arr,
                  game_options: _vm.game_data.game_options,
                  word_slot: _vm.game_data.word_slot
                },
                on: {
                  hide_preview: function($event) {
                    return _vm.hidePreview()
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }